import React, { useEffect, useState } from 'react'
import Carousel from 'react-material-ui-carousel'
import { makeStyles, Grid, Typography } from '@material-ui/core'
import { getFromApiWithoutToken } from 'actions'
import { useApiRequest } from 'utils/customHooks/useApiRequest'


const useCarouselStyles = makeStyles(theme => ({
   carousel: {
      marginBottom: theme.spacing(3)
   }
}))

function CarouselBanner() {
   const classes = useCarouselStyles()

   const [carouselItems, setCarouselItems] = useState([])

   const _getCarouselBannerItems = async () => {
      const sliderConfigUrl = `${process.env.REACT_APP_SLIDER_API}/slider-config.json`
      const carouselBannerItems = await getFromApiWithoutToken(sliderConfigUrl)
      setCarouselItems(carouselBannerItems)
   }

   const getCarouselBannerItems = useApiRequest(
      _getCarouselBannerItems,
      'Home: obtener carrusel',
      false
   )

   useEffect(() => {
      getCarouselBannerItems()
   }, [])

   return (
      carouselItems.length > 0 && (
         <Carousel
            fullHeightHover={false}
            autoPlay={true}
            animation={'fade'}
            indicators={true}
            cycleNavigation={true}
            navButtonsAlwaysVisible={false}
            className={classes.carousel}
         >
            {carouselItems.map((carouselItem, index) => (
               <CarouselBannerItem key={index} data={carouselItem} />
            ))}
         </Carousel>
      )
   )
}

export default CarouselBanner

// ---------------------------------------------------------------------

const useCarouselItemStyles = makeStyles(theme => ({
   carouselItem: {
      position: 'relative'
   },
   bannerHighlightedText: {
      position: 'absolute',
      backgroundColor: '#FFAA32',
      color: '#FFFFFF',
      top: '15px',
      padding: theme.spacing(0.5, 1),
      borderRadius: '0px 8px 8px 0px'
   },
   bannerTextContainer: {
      backgroundColor: '#3264DC',
      height: '216px',
      color: '#FFFFFF',
      paddingTop: '54px',
      paddingLeft: '4%',
      borderRadius: '4px 0px 0px 4px'
   },
   bannerLargeText: {
      font: 'normal normal bold 32px/43px Roboto',
      letterSpacing: '0px'
   },
   bannerMediumText: {
      font: 'normal normal normal 12px/16px Roboto',
      letterSpacing: '0px'
   },
   bannerTextSeparator: {
      marginBottom: theme.spacing(2)
   },
   bannerImageContainer: {
      height: '216px',
      borderRadius: '0px 4px 4px 0px'
   },
   bannerImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '0px 4px 4px 0px'
   },
   [theme.breakpoints.up('md')]: {
      carouselItem: {
         display: 'flex'
      },
      bannerTextContainer: {
         flex: '0 1 30%'
      },
      bannerImageContainer: {
         flex: '0 1 70%'
      }
   }
}))

function CarouselBannerItem({ data }) {
   const classes = useCarouselItemStyles()
   const imageUrlMd = `${process.env.REACT_APP_SLIDER_API}/${data.imageUrlMd}`

   return (
      <Grid className={classes.carouselItem}>
         <Grid className={classes.bannerHighlightedText}>
            <Typography className={classes.bannerMediumText}>
               {data.highlightedText}
            </Typography>
         </Grid>
         <Grid className={classes.bannerTextContainer}>
            <Typography className={classes.bannerLargeText}>
               {data.mainText}
            </Typography>
            <Typography
               className={`${classes.bannerMediumText} ${classes.bannerTextSeparator}`}
            >
               {data.secondaryText}
            </Typography>
            <Typography className={classes.bannerMediumText}>
               {data.buttonText}
            </Typography>
         </Grid>
         <Grid className={classes.bannerImageContainer}>
            <img
               src={imageUrlMd}
               alt={'Zona Ser'}
               className={classes.bannerImage}
            />
         </Grid>
      </Grid>
   )
}
